import React, { useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./index.module.css";
import { ChevronRight } from "react-ikonate";
// import Button, { ButtonLinkHollow } from "shared/Button";

export default function Section(props) {
  const [open, setOpen] = useState(props.open);

  return (
    <details
      className={styles.section}
      open={open}
      onToggle={(e) => {
        setOpen(e.target.open);
      }}
    >
      <summary className={styles.title}>
        <span className={styles.titleText}>{props.title}</span>

        <ChevronRight
          width={30}
          height={30}
          strokeWidth={1}
          className={classNames(styles.chevron, {
            [styles.turned]: open,
          })}
        />
      </summary>

      {props.children}
    </details>
  );
}

Section.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  children: PropTypes.node,
};
